// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".report-box .box-header {\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin-bottom: 1.5rem;\n  color: #0059A4;\n}\n.report-box .box-header .action {\n  padding-right: 1rem;\n}\n.report-box .box-header .action a {\n  color: grey;\n}\n.report-box .justify-center {\n  justify-content: center;\n}\n.report-box .align-end {\n  align-items: flex-end;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
